module.exports = __webpack_public_path__ + "static/media/logo-primary.ee1cb5a5.png";